// extracted by mini-css-extract-plugin
export default {"spinner-container":"AIGenerateList_spinner-container__5atjK","spinner":"AIGenerateList_spinner__bJAQf","spin":"AIGenerateList_spin__+G36G"};